import { createQueryNumberToggleHook } from "../../../../stores/useQueryState";

export const wheelPriceParamName = "wheel-price";

export const useWheelPrice = createQueryNumberToggleHook(
  wheelPriceParamName,
  []
);

/**
 * @see docs/worklog/TW-859-combos-wheel-filters/rfc.md
 * @see docs/worklog/TW-859-combos-wheel-filters/tfc.md
 */
